<template>
  <v-card
    class="invoice-parameter-card">
    <v-container fluid fill-height>
      <v-row>
        <v-col
          v-bind="colAttrs"
          class="invoice-parameter-column">
          <Autocomplete
            label="Operadora"
            @change="setInsuranceCarrier"
            :value="invoiceParameterFilter.carrierId"
            :items="carriers"
            item-text="xipp_commercial_name"
            item-value="id"
            hide-details
            v-bind="autocompleteAttrs"
          />
        </v-col>
        <v-col
          v-bind="colAttrs"
          class="invoice-parameter-column">
          <Autocomplete
            label="Grupo Financeiro"
            @change="setFinancialGroup"
            :value="invoiceParameterFilter.financialGroupId"
            :items="financialGroups"
            item-text="name"
            item-value="id"
            hide-details
            v-bind="autocompleteAttrs"
          />
        </v-col>
        <v-col
          v-bind="colAttrs"
          class="invoice-parameter-column">
          <Autocomplete
            label="Contrato"
            @change="setContract"
            :value="invoiceParameterFilter.contractId"
            :items="contracts"
            item-text="text"
            item-value="id"
            hide-details
            v-bind="autocompleteAttrs"
          />
        </v-col>
        <v-col
          v-bind="colAttrs"
          class="invoice-parameter-column">
          <Autocomplete
            label="Subcontrato"
            @change="setSubContract"
            :value="invoiceParameterFilter.subContractId"
            :items="subContracts"
            item-text="text"
            item-value="id"
            hide-details
            v-bind="autocompleteAttrs"
          />
        </v-col>
        <v-col
          v-bind="colStatusAttrs"
          class="statis-col-filter">
          <Autocomplete
            label="Status"
            @change="setStatus"
            :value="invoiceParameterFilter.active"
            :items="statusList"
            item-text="label"
            item-value="code"
            hide-details
            v-bind="autocompleteAttrs"
          />
        </v-col>
        <v-col
          v-bind="colActionAttrs"
          class="action-col-filter">
          <div
            :class="{
              'd-flex flex-row gap-h-20 justify-end': true,
            }">
            <Button
              class="ui-text-base"
              @click="search"
              :disabled="!hasFiltersSelected">
              <div
                class="mr-2"
                style="max-width: 18px;">
                <SvgIcon
                  contain
                  height="18"
                  src="icons/magnify.svg"
                />
              </div>
              Pesquisar
            </Button>
            <Button
              off
              class="ui-text-base"
              @click="resetFilter">
              Limpar Filtros
            </Button>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Autocomplete from '../Default/Autocomplete.vue';
import {
  FILTER_STATUS_COL,
  FILTER_ACTION_COL,
} from '@/shared/constants/invoiceParameter/FilterConstants';
import Button from "../Default/Button/Button.vue";
import SvgIcon from "../Default/SvgIcon.vue";
export default {
  name: "InvoiceParameterFilter",
  components: {
    Autocomplete,
    SvgIcon,
    Button,
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  methods: {
    ...mapActions({
      fetchContractsByFinancialGroupId: 'invoice-parameter/fetchContractsByFinancialGroupId',
      fetchSubContractsByContractId: 'invoice-parameter/fetchSubContractsByContractId',
      resetFilter: 'invoice-parameter/resetFilter',
      setFilter: 'invoice-parameter/applyFilter',
      search: 'invoice-parameter/search',
    }),
    ...mapMutations({
      resetFinancialGroups: 'invoice-parameter/resetFinancialGroups',
      resetSubContracts: 'invoice-parameter/resetSubContracts',
      resetContracts: 'invoice-parameter/resetContracts',
      resetCarriers: 'invoice-parameter/resetCarriers',
    }),
    async loadParameters() {
      if (this.parameters.carrierId) this.setInsuranceCarrier(Number(this.parameters.carrierId));
      if (this.parameters.financialGroupId) await this.setFinancialGroup(Number(this.parameters.financialGroupId));
      if (this.parameters.contractId) await this.setContract(Number(this.parameters.contractId));
      this.search();
    },
    setInsuranceCarrier(carrierId) {
      this.setFilter({carrierId: carrierId});
    },
    async setFinancialGroup(financialGroupId) {
      this.setFilter({financialGroupId: financialGroupId});

      this.setContract(null);
      this.setSubContract(null);
      this.resetContracts();
      this.resetSubContracts();

      if (financialGroupId) {
        await this.fetchContractsByFinancialGroupId(this.isRHProtegido);
      }
    },
    async setContract(contractId) {
      this.setFilter({contractId: contractId});

      this.setSubContract(null);
      this.resetSubContracts();

      if (contractId) {
        await this.fetchSubContractsByContractId();
      }
    },
    setSubContract(subContractId) {
      this.setFilter({subContractId: subContractId});
    },
    setStatus(status) {
      this.setFilter({active: status});
    },
  },
  computed: {
    ...mapGetters({
      hasFiltersSelected: 'invoice-parameter/hasFiltersSelected',
      financialGroups: 'invoice-parameter/financialGroups',
      invoiceParameterFilter: 'invoice-parameter/filter',
      subContracts: 'invoice-parameter/subContracts',
      statusList: 'invoice-parameter/statusList',
      isRHProtegido: 'user-info/isRHProtegido',
      contracts: 'invoice-parameter/contracts',
      carriers: 'invoice-parameter/carriers',
    }),
    colStatusAttrs() {
      return FILTER_STATUS_COL;
    },
    colActionAttrs() {
      return FILTER_ACTION_COL;
    },
  },
  async mounted() {
    await this.loadParameters();
  },
}
</script>

<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
@import "@/shared/styles/invoiceParameters/filter.scss";
</style>